.filterCard {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.filterActions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dateRangePickerCol {
  width: 288px;
}
